<template>
    <div>
        <div class="search">
            <!-- 筛选 -->
            <my-search
                timeScreen
                :order="2"
                :searchParams="searchParams"
                @searchEvent="searchEvent"
            />
            <el-button
                type="primary"
                icon="el-icon-plus"
                circle
                class="addBtn"
                @click="add"
            ></el-button>
        </div>

        <el-card shadow="never">
            <myTable
                :loading="loading"
                :tableData="tableData"
                :tableHeader="tableHeader"
            />
            <!-- 分页组件 -->
            <my-pagination :childMsg="pageParams" @callFather="callFather" />
            <!-- 添加、修改组件 -->
            <my-dialog
                :isDialogShow.sync="isDialogShow"
                :operTitle="operTitle"
                :operForm="operForm"
                :operFormArr="operFormArr"
                :rules="rules"
                :loading="loading"
                @submitForm="submitForm"
            />
            <!-- 详情组件 -->
            <my-dialog-detail
                :isDialogDetailShow.sync="isDialogDetailShow"
                :operForm="operForm"
                :operFormArr="operFormArr"
                :closeDialog="closeDialog"
            />
        </el-card>
    </div>
</template>
<script>
import {
    reqPageList,
    reqSave,
    reqUpdate,
    reqDelete,
} from "@/network/content/articleCategory";
import mixins from "@/mixins/common";
import { canSearch } from "../../utils/utils";
export default {
    name: "articleCategory",
    mixins: [mixins],
    data() {
        return {
            tableHeader: Object.freeze([
                {
                    name: "name",
                    prop: "name",
                },
                {
                    name: "img",
                    prop: "img",
                },
                {
                    name: "type",
                    prop: "type",
                },
                {
                    name: "url",
                    prop: "url",
                },
                {
                    name: "创建时间",
                    prop: "createTime",
                },
                {
                    name: "操作",
                    prop: "operation",
                    width: "300",
                    operation: [
                        {
                            name: "详情",
                            clickFun: this.detail,
                            icon: "el-icon-share",
                            // type: "primary",
                        },
                        {
                            name: "编辑",
                            clickFun: this.edit,
                            icon: "el-icon-edit",
                            // type: "primary",
                        },
                        {
                            name: "删除",
                            clickFun: this.delete,
                            icon: "el-icon-delete",
                            // type: "primary",
                        },
                    ],
                },
            ]),
            searchParams: {
                timeOptions: [],
            },
            //添加、编辑时文本框所需参数
            operFormArr: [
                {
                    name: "name",
                    label: "name",
                    defaultText: "请输入name",
                },
                // {
                //   name: "type",
                //   label: "type",
                //   defaultText: "请输入type",
                // },
                {
                    name: "img",
                    label: "img",
                    defaultText: "请输入img",
                },
                {
                    name: "url",
                    label: "url",
                    defaultText: "请输入url",
                },
            ],
            //添加、编辑双向绑定值
            operForm: {
                name: "",
                // type: "",
                url: "",
                img: "",
            },
            // 弹出框的表单验证
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入name",
                        trigger: "blur",
                    },
                ],
                img: [
                    {
                        required: true,
                        message: "请输入img",
                        trigger: "blur",
                    },
                ],
                url: [
                    {
                        required: true,
                        message: "请输入url",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    methods: {
        async getInitData(isSearch) {
            let { timeOptions } = this.searchParams;
            let params = {
                data: { type: 3 },
                startTime: timeOptions ? timeOptions[0] : "",
                endTime: timeOptions ? timeOptions[1] : "",
                current: isSearch ? 1 : this.pageParams.currentPage,
                size: this.pageParams.pageSize,
            };
            let { data } = await reqPageList(params);
            if (data.code == 200) {
                this.loading = false;
                this.tableData = data.data.records;
                this.pageParams.total = data.data.total;
                if (isSearch) this.pageParams.currentPage = 1;
            }
        },
        //搜索
        searchEvent() {
            if (canSearch(this, this.searchParams)) return;
            console.log("搜索了");
            this.getInitData(true);
        },
        //  增加
        add() {
            // 清空
            this.operForm = { type: 3 };
            this.operTitle = true;
            this.isDialogShow = true;
        },
        // 查
        detail(row) {
            this.isDialogDetailShow = true;
            // 显示
            this.operForm = {
                ...row,
            };
        },
        // 修改
        edit(row) {
            this.operTitle = false;
            this.isDialogShow = true;
            // 显示
            this.operForm = {
                ...row,
            };
        },
        // 确认修改
        async submitForm({ valid, operTitle }) {
            // operTitle ture添加  否则是编辑
            if (valid) {
                let api = operTitle ? reqSave : reqUpdate;
                let { data } = await api(this.operForm);
                // console.log(data);
                if (data.code == 200) {
                    this.isDialogShow = false;
                    this.$message.success("操作成功");
                    this.getInitData();
                }
            }
        },
        // 删除
        delete(row) {
            this.$confirm("删除该条数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let { data } = await reqDelete(row.id);
                    if (data.code == 200) {
                        this.$message.success("删除成功");
                        this.getInitData();
                    }
                })
                .catch(() => {});
        },
    },
};
</script>

<style lang="scss" scoped>
.search {
    height: 100px;
    background-color: #f2f2f2;
    display: flex;
    align-items: center;
    padding: 0 30px;
}
.addBtn {
    margin: 0 0 10px 20px;
}
</style>